import React from 'react';
import { NavLink } from 'react-router-dom';
import { signOut } from 'aws-amplify/auth';
import './Sidebar.css';

const NAV_ITEMS = [
  { path: '/',              label: '広告主リスト', icon: '🏢' },
  { path: '/keywords',      label: 'キーワード管理', icon: '🔍' },
  { path: '/scrape',        label: 'スクレイピング', icon: '🕷️' },
  { path: '/mail-settings', label: 'メール設定',    icon: '📧' },
];

const Sidebar: React.FC = () => {
  const handleSignOut = async () => {
    await signOut();
    window.location.reload();
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <span className="logo-icon">📡</span>
        <span className="logo-text">AdRadar</span>
      </div>

      <nav className="sidebar-nav">
        {NAV_ITEMS.map(item => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === '/'}
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
          >
            <span className="nav-icon">{item.icon}</span>
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <button className="signout-btn" onClick={handleSignOut}>
        🚪 サインアウト
      </button>
    </aside>
  );
};

export default Sidebar;
